import React from "react";

const Info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i className="bx bx-award about__icon"></i>
        <h3 className="about__title">Experience</h3>
        <span className="about__subtitle">
          5 Years
          <br />
          Working
        </span>
      </div>

      <div className="about__box">
        <i className="bx bx-briefcase-alt about__icon"></i>
        <h3 className="about__title">Education</h3>
        <span className="about__subtitle">
          Master's
          <br />
          degree
        </span>
      </div>

      <div className="about__box">
        <i className="bx bx-certification about__icon"></i>
        <h3 className="about__title">Certifications</h3>
        <span className="about__subtitle">
          AZ-900
          <a
            href="https://www.credly.com/badges/f4757e1b-a38c-42f1-920f-5901a5e31530/public_url"
            target="_blank"
            title="See my badge for Azure AZ-900"
            rel="noopener noreferrer"
          >
            <sup>
              {" "}
              <i class="uil uil-external-link-alt"></i>
            </sup>
          </a>
          <br />
          AZ-204
          <a
            href="https://www.credly.com/badges/52635c0d-1da4-40a2-be7a-c03c16daa518/public_url"
            target="_blank"
            title="See my badge for Azure AZ-204"
            rel="noopener noreferrer"
          >
            <sup>
              {" "}
              <i class="uil uil-external-link-alt"></i>
            </sup>
          </a>
        </span>
      </div>
    </div>
  );
};

export default Info;
